import { Icon, useTranslation } from '@testsigma/atoms';
import React, { FC } from 'react';
import { CHROME_WEB_STORE_RECORDER_URL } from '@constants';

interface RecorderUpgradeBannerProps {
  onClose: () => void;
}

const RecorderUpgradeBanner: FC<RecorderUpgradeBannerProps> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className='w-full relative flex flex-row items-center justify-center'>
      <div className='flex items-center justify-center w-full'>
        <span className='text-md text-unique-600'>
          <span className='font-normal'>
            {t('announcement_banner.recorder_outdated')}
          </span>{' '}
          <a
            href={CHROME_WEB_STORE_RECORDER_URL}
            target='_blank'
            rel='noopener noreferrer'
            className='font-bold underline text-unique-600 hover:text-unique-800'
          >
            {t('announcement_banner.recorder_update_cta')}
          </a>
        </span>
        <Icon
          name='close'
          className='text-[24px] text-unique-600 items-center cursor-pointer flex-shrink-0 absolute right-0'
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default RecorderUpgradeBanner;
